import { Notification } from "@otp/ui";
import { useTranslation } from "react-i18next";
import { StoreModel } from "src/graphql/generated/graphql";

type RestaurantNeedAttentionReasonsProps = {
  store: Partial<StoreModel>;
};

export const RestaurantNeedAttentionReasons = ({
  store,
}: RestaurantNeedAttentionReasonsProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "manage-restaurants.need-attention-reasons",
  });
  const storeNeedAttentionReasons = store.needAttentionReasons || [];

  return (
    <div className="flex flex-col gap-3">
      {storeNeedAttentionReasons.map((reason) => (
        <Notification key={reason} severity="error" centered icon={false}>
          {t(reason)}
        </Notification>
      ))}
    </div>
  );
};
